import React from "react";

import { FormattedMessage } from "react-intl";

import { CwsH3 } from "cms-web-styleguide/dist/components/CwsTypography/CwsH3/CwsH3";
import { CwsIcon } from "cms-web-styleguide/dist/components/CwsIcon/CwsIcon";

import styles from "./TitleWithImg.module.scss";

const TitleWithImg = () => {
  return (
    <div className={styles["cwc-title"]}>
      <CwsIcon icon="cookie" mode="dom" size="40px" />

      <CwsH3 hideSpacing>
        <FormattedMessage id="banner.title" />
      </CwsH3>
    </div>
  );
};

export { TitleWithImg };
